// extracted by mini-css-extract-plugin
module.exports = {"entityRadio":"entityRadio--Qw5lk","text":"text--xh17S"};